import caseTimeLog from "apis/caseTimeLog";
import inspectors from "apis/inspectors";
import { WebApiRequest, HTTP_GET, HTTP_POST } from "tools/webservice";

export const getPayPeriodList = (successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: caseTimeLog.getPayPeriodList(),
  successCallback,
  mountedRef,
});
export const getCaseIssues = (frNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: inspectors.getCaseIssues(frNumber),
  successCallback,
  mountedRef,
});
export const createFieldRep = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: inspectors.createInspector(),
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});
export const getInspectorsForCase = (request, successCallback, mountedRef, errorCallback = null) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/inspector/case/${request.controlIdNumber}/eligible`,
  successCallback,
  errorCallback,
  mountedRef,
  payload: request,
});
/**
 * Get an inspector's service regions
 * @param {integer} inspectorNumber 
 * @param {function} successCallback 
 * @param {Ref} mountedRef 
 * @returns
 */
export const getServiceRegions = (inspectorNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/inspector/${inspectorNumber}/service-regions`,
  successCallback,
  mountedRef,
});
/**
 * Set an inspector's service regions
 * @param {integer} inspectorNumber 
 * @param {integer[]} serviceRegionIds 
 * @param {function} successCallback 
 * @param {Ref} mountedRef 
 * @returns
 */
export const setServiceRegions = (inspectorNumber, serviceRegionIds, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/inspector/${inspectorNumber}/service-regions`,
  payload: serviceRegionIds,
  successCallback,
  mountedRef,
});